import { FormContent } from '../../FinalRequestDraft/FinalRequestForm/FormContent';
import { useParams } from 'react-router-dom';

export const FinalRequestFormReadOnlyView = () => {
  const { id } = useParams();
  return <FormContent draftId={id as string} readOnly={true} />;
};
